module.exports = __webpack_public_path__ + "static/media/zolaicons.0d311969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/zolaicons.svg?24613844
// module id = 3854
// module chunks = 68